"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareNavItems = void 0;
var compareNavItems = function (a, b) {
    return a.order === b.order ? 0 : (a.order || 0) > (b.order || 0) ? 1 : -1;
};
exports.compareNavItems = compareNavItems;
//# sourceMappingURL=NavItem.js.map